import { Page } from '@app/components/page/Page';
import { useStation } from '@app/core/stations/hooks/useStation';
import { StationLabel } from '@app/modules/admin/screens/stations/list/StationLabel';
import { SocialExportBreadcrumbs } from '@app/modules/social-export/components/breadcrumbs/SocialExportBreadcrumbs';
import { YoutubePlatform } from '@app/modules/social-export/domain/platforms';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import { youtubeCuepointsMessages } from './messages/youtube-cuepoints-messages';
import { YoutubeCuepointsList } from './YoutubeCuepointsList';

/**
 * Admin page listing YouTube cuepoints for a connected station, filtered by target date.
 */
export function YoutubeCuepointsPage() {
  const { station: stationId } = useParams<{ station: string }>();
  const station = useStation(stationId!);
  const { formatMessage } = useIntl();

  const title = formatMessage(youtubeCuepointsMessages.pageTitle);

  return (
    <Page htmlTitle={`${title} | ${station.name}`}>
      <Page.Header
        icon={YoutubePlatform.Icon()}
        title={title}
        breadcrumbs={
          <SocialExportBreadcrumbs
            platform={YoutubePlatform}
            items={[{ content: <StationLabel station={station} size="sm" /> }]}
          />
        }
      />
      <YoutubeCuepointsList stationId={stationId!} />
    </Page>
  );
}
